const objectSize = obj => Object.keys(obj).length;
export default objectSize;
